import React, { useEffect, useRef, useState } from "react";
import {
  DoubleSide,
  MathUtils,
  Mesh,
  MeshBasicMaterial,
  MeshStandardMaterial,
  PlaneGeometry,
  RepeatWrapping,
  SphereGeometry,
  TextureLoader,
  Vector3,
  PMREMGenerator,
  DirectionalLight,
  AmbientLight
} from "three";
import effectController from "./effectsController";
import { Sky } from "three/examples/jsm/objects/Sky.js";
import { Water } from "three/examples/jsm/objects/Water.js";

// import { Sky } from './Sky'
import sky from "../../assets/sky1.jpg";
import night from "../../assets/night.jpg";
import sunset from "../../assets/sunset.jpg";
import waterUrl from "../../assets/waternormals.jpg";

// import full360 from "../../assets/360/DJI_360.JPG"
import gui from "../../utils/gui";


import Stars from "./Stars";
import gsap from "gsap";
import { createSunPosition } from "../../utils/threeJsUtils";


export const skies = {
  Day: sky,
  Night: night,
  Sunset: sunset,
};
const SkyController = ({
  scene,
  // gridSize,
  showOcean,
  renderer,
  animationEnded,
  modelsLoaded,
  environmentPreset,
  selectedFloor,
  showEnvironment,
}) => {
  const skyDome = useRef();
  const loader = useRef();
  const sun = useRef();
  const sky = useRef();
  const water = useRef();
  const ldrCubeMap = useRef();
  const ambientLight = useRef();

  useEffect(() => {
    if (!sky.current) {
      loader.current = new TextureLoader();
      // sun.current = buildSun();
      sky.current = buildSky();
      water.current = buildWater();
      addSunlight();
      addLighting()
      // loadEnvironment();
      // const pmremGenerator = new PMREMGenerator(renderer);
      // scene.environment = pmremGenerator.fromScene(sky.current).texture;
      // addGiuControls();
      guiChanged();

      // if (!skyDome.current) loadSky(skies.Day)
      // createSky();
      // createGroundPlane();
    }
    return () => {
      if (skyDome.current) {
        scene.remove(skyDome.current);
      }
    };
  }, []);
  useEffect(() => {
    const waterSpeed = 0.1;
    const animate = () => {
      if (water.current) {
        water.current.material.uniforms["time"].value += waterSpeed / 60.0;
      }
      requestAnimationFrame(animate);
    };

    animate();
  }, []);
  useEffect(() => {
    if (modelsLoaded) {
      if (!animationEnded) animateSkyTransition(effectController["Sunset"], 10);
      else animateSkyTransition(effectController["Sunset"], 1);
    }

    return () => { };
  }, [modelsLoaded]);
  // sunColor
  // waterColor
  useEffect(() => {
    handlePresetChange();
    return () => { };
  }, [environmentPreset]);

  useEffect(() => {
    if (!selectedFloor) {
      // scene.background = null;
      handleShowEnvironmentChange();
      animateSkyTransition(effectController[environmentPreset], 3);
    }
    else {

      // scene.background = ldrCubeMap.current;
      // fade out sky water and grid          
      if (sky.current) {
        sky.current.visible = false
        // gsap.to(sky.current.scale, {
        //   duration: 1,
        //   x: 0,
        //   y: 0,
        //   z: 0,
        // });
      }
      if (water.current) {
        water.current.visible = false
        // gsap.to(water.current.scale, {
        //   duration: 1,
        //   x: 0,
        //   y: 0,
        //   z: 0,
        // });
      }

    }
    return () => { };
  }, [selectedFloor]);

  useEffect(() => {
    console.log("sky controller showEnvironment changed:", showEnvironment);
    handleShowEnvironmentChange();
    return () => {};
  }, [showEnvironment]);

  const handleShowEnvironmentChange = () => {
    if (!showEnvironment) {
      if (sky.current) {
        sky.current.visible = false;
      }
      if (water.current) {
        water.current.visible = false;
      }
    } else {
      if (sky.current) {
        sky.current.visible = true;
      }
      if (water.current && showOcean) {
        water.current.visible = true;
      }
    }
  };
  useEffect(() => {
    handleShowEnvironmentChange();
  }, [showEnvironment]);
  const animateSkyTransition = (targetPreset, duration = 3, onComplete) => {
    console.log("Animating sky uniforms", targetPreset.ambientLightIntensity);
    const uniforms = sky.current.material.uniforms;

    const currentValues = {
      turbidity: uniforms["turbidity"].value,
      rayleigh: uniforms["rayleigh"].value,
      mieCoefficient: uniforms["mieCoefficient"].value,
      mieDirectionalG: uniforms["mieDirectionalG"].value,
      ...getElevationAndAzimuth(uniforms["sunPosition"].value),
    };

    const endValues = {
      turbidity: targetPreset.turbidity,
      rayleigh: targetPreset.rayleigh,
      mieCoefficient: targetPreset.mieCoefficient,
      mieDirectionalG: targetPreset.mieDirectionalG,
      elevation: targetPreset.elevation,
      azimuth: targetPreset.azimuth,
    };

    // Check if the target preset is the same as the current values
    if (JSON.stringify(currentValues) === JSON.stringify(endValues)) {
      console.log(
        "Target preset is the same as current values. No animation needed."
      );
      return;
    }
    if (ambientLight.current && targetPreset.ambientLightIntensity) {

      ambientLight.current.intensity = targetPreset.ambientLightIntensity;
    }
    gsap.to(currentValues, {
      duration: duration,
      turbidity: endValues.turbidity,
      rayleigh: endValues.rayleigh,
      mieCoefficient: endValues.mieCoefficient,
      mieDirectionalG: endValues.mieDirectionalG,
      elevation: endValues.elevation,
      azimuth: endValues.azimuth,
      // ambientLightIntensity: endValues.ambientLightIntensity,
      onUpdate: () => {
        uniforms["turbidity"].value = currentValues.turbidity;
        uniforms["rayleigh"].value = currentValues.rayleigh;
        uniforms["mieCoefficient"].value = currentValues.mieCoefficient;
        uniforms["mieDirectionalG"].value = currentValues.mieDirectionalG;

        const sunPosition = createSunPosition(
          currentValues.elevation,
          currentValues.azimuth
        );
        // console.log("sunPosition", sunPosition);
        sun.current.position.set(sunPosition.x * 100, sunPosition.y * 100, sunPosition.z * 100);
        uniforms["sunPosition"].value.copy(sunPosition);

        if (ambientLight.current) {
          // console.log(currentValues.ambientLightIntensity)
          // ambientLight.current.intensity = currentValues.ambientLightIntensity;
        }
      },
      onComplete: () => {
        // Ensure the uniforms match the end values when the animation completes
        uniforms["turbidity"].value = endValues.turbidity;
        uniforms["rayleigh"].value = endValues.rayleigh;
        uniforms["mieCoefficient"].value = endValues.mieCoefficient;
        uniforms["mieDirectionalG"].value = endValues.mieDirectionalG;

        const sunPosition = createSunPosition(
          endValues.elevation,
          endValues.azimuth
        );
        uniforms["sunPosition"].value.copy(sunPosition);
        if (ambientLight.current) {
          // alert(endValues.ambientLightIntensity)
          // ambientLight.current.intensity = endValues.ambientLightIntensity;
        }
        onComplete && onComplete();
      },
    });
  };

  const handlePresetChange = () => {
    console.log("Sky controller handlePresetChange", environmentPreset);
    console.log({ animationEnded })
    if (animationEnded) {
      if (effectController[environmentPreset]) {
        // scene.background = null;
        if (sky.current) {
          sky.current.visible = true
        }
        if (water.current) {
          water.current.visible = true
        }
        animateSkyTransition(effectController[environmentPreset], 3);
      }
      else {

        // scene.background = ldrCubeMap.current;
        // fade out sky water and grid          
        if (sky.current) {
          sky.current.visible = false
          // gsap.to(sky.current.scale, {
          //   duration: 1,
          //   x: 0,
          //   y: 0,
          //   z: 0,
          // });
        }
        if (water.current) {
          water.current.visible = false
          // gsap.to(water.current.scale, {
          //   duration: 1,
          //   x: 0,
          //   y: 0,
          //   z: 0,
          // });
        }

      }
      if (!showOcean) return;
      if (environmentPreset === "Grid") {
        //fade out water
        gsap.to(water.current.scale, {
          duration: 1,
          x: 0,
          y: 0,
          z: 0,
        });
      } else {
        //fade in water
        gsap.to(water.current.scale, {
          duration: 1,
          x: 1,
          y: 1,
          z: 1,
        });
      }
    }
  };
  const addLighting = () => {

    ambientLight.current = new AmbientLight(0xffffff, 0.8);
    scene.add(ambientLight.current);
  }
  const addGiuControls = () => {
    gui.get((gui) => {
      gui
        .add(effectController[environmentPreset], "turbidity", 0.0, 20.0, 0.1)
        .onChange(guiChanged);
      gui
        .add(effectController[environmentPreset], "rayleigh", 0.0, 4, 0.001)
        .onChange(guiChanged);
      gui
        .add(
          effectController[environmentPreset],
          "mieCoefficient",
          0.0,
          0.1,
          0.001
        )
        .onChange(guiChanged);
      gui
        .add(
          effectController[environmentPreset],
          "mieDirectionalG",
          0.0,
          1,
          0.001
        )
        .onChange(guiChanged);
      gui
        .add(effectController[environmentPreset], "elevation", -360, 360, 0.01)
        .onChange(guiChanged);
      gui
        .add(effectController[environmentPreset], "azimuth", -180, 180, 0.1)
        .onChange(guiChanged);
      // gui.add(effectController, "exposure", 0, 1, 0.0001).onChange(guiChanged);

      guiChanged();
    });
  };
  const addSunlight = () => {
    const sunlight = new DirectionalLight(0xffffff, 1);
    sunlight.position.set(200, 200, 100); // Position the light
    sunlight.castShadow = true; // Enable shadows for the light

    // Configure shadow properties
    sunlight.shadow.mapSize.width = 2048; // Shadow map resolution
    sunlight.shadow.mapSize.height = 2048;
    sunlight.shadow.camera.near = 0.5; // Near clipping plane
    sunlight.shadow.camera.far = 1000; // Far clipping plane
    sunlight.shadow.camera.left = -1000; // Left extent of the shadow camera
    sunlight.shadow.camera.right = 1000; // Right extent of the shadow camera
    sunlight.shadow.camera.top = 1000; // Top extent of the shadow camera
    sunlight.shadow.camera.bottom = -1000; // Bottom extent of the shadow camera
    sun.current = sunlight;
    scene.add(sun.current);
  };
  // Converts elevation and azimuth angles to Cartesian coordinates (x, y, z)

  // Converts Cartesian coordinates (x, y, z) to elevation and azimuth angles
  function getElevationAndAzimuth(sunPosition) {
    const { x, y, z } = sunPosition;

    const r = Math.sqrt(x * x + y * y + z * z); // Radius
    const phi = Math.acos(y / r); // Polar angle in radians
    const theta = Math.atan2(z, x); // Azimuthal angle in radians

    const elevation = 90 - phi * (180 / Math.PI); // Convert to degrees
    const azimuth = theta * (180 / Math.PI); // Convert to degrees

    return { elevation, azimuth };
  }

  function guiChanged() {
    if (!sky.current) return;
    console.log("guiChanged", effectController[environmentPreset]);
    const uniforms = sky.current.material.uniforms;
    uniforms["turbidity"].value = effectController[environmentPreset].turbidity;
    uniforms["rayleigh"].value = effectController[environmentPreset].rayleigh;
    uniforms["mieCoefficient"].value =
      effectController[environmentPreset].mieCoefficient;
    uniforms["mieDirectionalG"].value =
      effectController[environmentPreset].mieDirectionalG;

    const sunPosition = createSunPosition(
      effectController[environmentPreset].elevation,
      effectController[environmentPreset].azimuth
    );

    uniforms["sunPosition"].value.copy(sunPosition);
    sun.current.position.set(sunPosition.x * 100, sunPosition.y * 100, sunPosition.z * 100);
    renderer.toneMappingExposure = effectController[environmentPreset].exposure;
  }
  function buildSky() {
    const sky = new Sky();
    sky.scale.setScalar(10000);
    // console.log("sky", sky);
    scene.add(sky);
    return sky;
  }
  function buildSun() {
    const sun = createSunPosition(
      effectController[environmentPreset].elevation,
      effectController[environmentPreset].azimuth
    );

    // Defining the x, y and z value for our 3D Vector
    // const theta = Math.PI * (0.49 - 0.5);
    // const phi = 2 * Math.PI * (0.205 - 0.5);
    // sun.x = Math.cos(phi);
    // sun.y = Math.sin(phi) * Math.sin(theta);
    // sun.z = Math.sin(phi) * Math.cos(theta);

    return sun;
  }
  function buildWater() {
    console.log("Building water", showOcean);
    if (!showOcean) return null;
    const waterGeometry = new PlaneGeometry(10000, 10000);
    const water = new Water(waterGeometry, {
      textureWidth: 512,
      textureHeight: 512,
      waterNormals: loader.current.load(waterUrl, function (texture) {
        texture.wrapS = texture.wrapT = RepeatWrapping;
      }),
      alpha: 1.0,
      sunDirection: new Vector3(),
      sunColor: 0xffffff,
      waterColor: 0x001e0f,
      distortionScale: 3.7,
      fog: scene.fog !== undefined,
    });
    water.rotation.x = -Math.PI / 2;
    // water.position.y = -100;
    scene.add(water);

    return water;
  }

  return (
    <>
      <Stars scene={scene} show={environmentPreset !== "Grid" && showEnvironment} />
      {/* <Terrain scene={scene} settings={{
        show: environmentPreset == "360",
      }} /> */}

    </>
  );
};

export default SkyController;
